import { Divider, Group, Stack } from '@mantine/core';
import { Title } from '@repo/foundations';
import type { AutomationJob } from '../../../../api/types/models/automation/automationJob';
import { AutomationJobActivity } from '../../../../components/AutomationV2/JobDrawer/AutomationJobActivity';
import { AutomationJobDrawerResourceTable } from '../../../../components/AutomationV2/JobDrawer/AutomationJobDrawerResourceTable';
import { AutomationJobDrawerSummary } from '../../../../components/AutomationV2/JobDrawer/AutomationJobDrawerSummary';
import type { IResourceContentProps } from '../../types';

export function ResourceAutomationReviewContent({
	selected,
	completeAutomationReviewMutation,
}: IResourceContentProps) {
	const automationJob = selected.computedMetadata
		.automationJob as AutomationJob | null;

	if (!automationJob || !completeAutomationReviewMutation) {
		return null;
	}

	return (
		<Stack spacing="2xl">
			<Group pt="xl" pb="xs" spacing="xs">
				<Title size="xl">{selected.resource_title || 'Untitled'}</Title>
			</Group>
			<AutomationJobDrawerSummary automationJob={automationJob} />
			<Divider />
			<AutomationJobDrawerResourceTable
				automationJob={automationJob}
				handleCompleteAutomationReview={completeAutomationReviewMutation}
			/>
			<AutomationJobActivity automationJob={automationJob} />
		</Stack>
	);
}
